import { findClosestIndex } from './findClosestIndex';
import { rotate } from './rotate';
import { subtract } from './subtract';
import { add } from './add';
import { multiply } from './multiply';
import { divide } from './divide';

export const X = {
  findClosestIndex,
  rotate,
  subtract,
  add,
  multiply,
  divide
};
